import React from 'react'

import GovRegistrationHeading from './views'
import CCMSRegistrations from './ccms-registrations'
import CCSRegistrations from './ccs-registrations'

export const GovRegistration = ({ record }) => (
  <GovRegistrationHeading record={record}>
    <CCSRegistrations type_id={record.type_id} type={record.type} />
    <CCMSRegistrations record={record} />
  </GovRegistrationHeading>
)

export default GovRegistration



// WEBPACK FOOTER //
// ./src/gov-registrations/details/container.js